<template>
  <div>
    <template v-if="entry.image && entry.image[0]">
      <ArticleHeader :image-src="entry.image[0].url" :alt="entry.image[0].title">
        <div class="flex flex-row items-center space-x-4">
          <TagBtn
            v-if="entry.topics[0]"
            :to="{
              name: `knowledge-index-topic___${$i18n.locale}`,
              params: { topic: entry.topics[0].slug },
            }"
          >
            {{ entry.topics[0].title }}
          </TagBtn>
          <TagBtn
            v-if="entry.categories[0]"
            :to="{
              name: `knowledge-index-category-slug___${$i18n.locale}`,
              params: { slug: entry.categories[0].slug },
            }"
            secondary
          >
            {{ entry.categories[0].title }}
          </TagBtn>
          <TimeToRead v-if="entry.readTime" class="fluid-sm leading-tightest font-medium" :read-time="entry.readTime" />
        </div>
        <h1 class="lg:mt-4 mt-2 fluid-3xl leading-tightest">{{ entry.heading }}</h1>
        <PublishedLine
          :author="entry.expert[0]"
          :topic="entry.topics[0]"
          :at="entry.postDate"
          :modified="entry.dateUpdated"
          class="block mt-4"
        />
      </ArticleHeader>
    </template>
    <template v-if="entry.expert && entry.expert[0]">
      <AuthorInformation :author="entry.expert[0]" class="container max-w-screen-md mt-12" />
    </template>
    <ContentBlocks :entry="entry" class="mt-12" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import TagBtn from '@/components/common/TagBtn';
import PublishedLine from '@/components/article/PublishedLine';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';
import AuthorInformation, { AuthorInformationFragment } from '@/components/article/AuthorInformation';
import { SchemaOrgFragment } from '@/components/common/SchemaOrgFragment.gql';
import ArticleHeader from '@/components/article/ArticleHeader';
import TimeToRead from '@/components/common/TimeToRead';
import { generateSchema as generateArticlePageSchema } from './ArticlePage.schema';
import { useAppStore } from '@/stores/app';

export const ArticlePageFragment = gql`
  fragment ArticlePageFragment on article_Entry {
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
    seoTopics
    title
    heading
    readTime
    postDate
    dateUpdated
    slug
    image {
      url
      title
    }
    topics(limit: 1) {
      title
      slug
      id
    }
    categories: knowledgeCategories(limit: 1) {
      title
      slug
      id
    }
    expert {
      ...AuthorInformationFragment
    }
    ...SchemaOrgFragment
  }
  ${ContentBlocksMatrixFragment}
  ${AuthorInformationFragment}
  ${SchemaOrgFragment}
`;

export default defineNuxtComponent({
  name: 'ArticlePage',
  components: {
    TimeToRead,
    TagBtn,
    PublishedLine,
    ContentBlocks,
    AuthorInformation,
    ArticleHeader,
  },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
    seomatic: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { registerComponentSchema, DEFAULT_PAGE_SCHEMA } = useSchema();
    const { locale } = useI18n();

    // Generate schema once on mount
    if (props.entry) {
      // Get siteIdentity from Pinia store
      const appStore = useAppStore();
      const siteIdentity = appStore.siteIdentity || {};

      const schema = generateArticlePageSchema(props.entry, props.seomatic, locale.value, siteIdentity);
      registerComponentSchema(schema, DEFAULT_PAGE_SCHEMA);
    }
  },
});
</script>
